var translation = {
	Navatar: {
		header: "AWS Profile",
		subheader: "Your profile helps improve your interactions with select AWS experiences.",
		profileButtonText: "View profile",
		logOutText: "Log out",
		logInText: "Log in",
		createProfileText: "Create profile",
		federateLoginModalTitle: "Use Midway to access your AWS Profile",
		federateLoginModalFirstDescription: "As an Amazon employee, we recommend using Midway to access your AWS Profile. This security-recommended method provides seamless integration with internal systems.",
		federateLoginModalSecondDescription: "You're seeing this message because you've logged in with an Amazon email address using AWS Builder ID. This prompt will appear each time you log in until you switch to Midway or choose to continue with your current login.",
		federateLoginModalPrimaryButton: "Sign in with Midway",
		federateLoginModalSecondaryButton: "Continue with AWS Builder ID"
	}
};
var Navatar = {
	translation: translation
};

export { Navatar as default, translation };
